import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';

/**
 * Right-slide Sidebar used by MyAgentProfile (and any future page) for
 * inline section editing. Standardises header, footer (Save / Cancel),
 * and a mobile-safe responsive width.
 *
 * Props:
 *   visible       — bool
 *   onHide        — close handler (also fired by Cancel)
 *   title         — header text
 *   onSave        — Save handler
 *   saveLabel     — defaults to "Save"
 *   cancelLabel   — defaults to "Cancel"
 *   saveDisabled  — disables the Save button (e.g. while a network call is in flight)
 *   saveLoading   — shows a spinner inside the Save button
 *   width         — Sidebar width (default `min(480px, 100vw)`)
 */
const InlineEditSidebar = ({
    visible,
    onHide,
    title,
    onSave,
    saveLabel = 'Save',
    cancelLabel = 'Cancel',
    saveDisabled = false,
    saveLoading = false,
    width = 'min(480px, 100vw)',
    children,
}) => (
    <Sidebar
        visible={visible}
        onHide={onHide}
        position="right"
        style={{ width }}
        pt={{ content: { className: 'p-0' } }}
        header={
            <div className="flex align-items-center gap-2">
                <i className="pi pi-pencil text-primary" aria-hidden="true" />
                <span className="text-900 font-semibold">{title}</span>
            </div>
        }
    >
        <div className="flex flex-column" style={{ height: '100%' }}>
            <div className="flex-grow-1 overflow-y-auto p-3">{children}</div>
            <div className="flex justify-content-end gap-2 p-3 surface-border border-top-1">
                <Button
                    label={cancelLabel}
                    severity="secondary"
                    outlined
                    size="small"
                    onClick={onHide}
                    disabled={saveLoading}
                />
                <Button
                    label={saveLabel}
                    icon="pi pi-check"
                    size="small"
                    disabled={saveDisabled || saveLoading}
                    loading={saveLoading}
                    onClick={onSave}
                />
            </div>
        </div>
    </Sidebar>
);

export default InlineEditSidebar;
